import React, { Component } from 'react';
import { withRouter, Link } from "react-router-dom";
import { FormControl, FormGroup, Row, Col, Alert, Button} from 'react-bootstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';
import { msgs } from 'src/js/ErrorMessage.js';
import 'src/css/LoginForm.css'
import 'src/i18n';
import { withTranslation, Trans } from 'react-i18next';

class LoginForm extends Component {

  constructor() {
    super();    
    this.onClick = this.onClick.bind(this);
    // 画面最上部まで移動
    window.scrollTo(0,0);
  }

  onClick() {
    this.props.authenticate(this.inputId.value, this.inputPassword.value);
    console.log(this.inputId);
    console.log(this.inputId.value);
  }

  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
        {
          this.props.isFail ? <Alert bsStyle="danger">
          <p>
              <Trans i18nKey={"Message." + msgs['msg_login_01']}>
               {msgs['msg_login_01']}
              </Trans>
            </p>
            </Alert> : false
        }
      </div>
    );

    const LoginButton = () => (
      <button type="submit" id="circleButton" className="loginButton" disabled={this.props.signInLoading} onClick={this.onClick}>
        {
          this.props.signInLoading ? <FontAwesomeIcon size='1x' icon={faSpinner} spin /> : <Trans i18nKey="Login.Login">Login</Trans>
        }
      </button>
    );

    return (
      <div>
        <Row>
          <Col xs={10} xsOffset={1}>
            <Error />
          </Col>
        </Row>
        {/* ID入力フォーム */}
        <FormGroup controlId="formHorizontalId" >
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="Common.ID">VIN No.</Trans></p>
              <p className="formTextDescription"><Trans i18nKey="Login.IdDescription">*refer to My Toyota menu -&gt; Vehicle Info</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="text" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputId = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* パスワード入力フォーム */}
        <FormGroup controlId="formHorizontalPassword">
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="Common.Password">Password</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="password" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputPassword = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* ログインボタン */}
        <div className='short-div' />
        <FormGroup>
          <Row id="button-forms">
            <LoginButton />
            <div className="explanation">
              <Trans i18nKey="Login.SignUpDescription">
                If you don`t have an account,<br/>
                please click the button below to create one.
              </Trans>
            </div>
            <Link to="/signup">
              <Button id="move-button">
                <Trans i18nKey="Login.SignUp">Create Account</Trans>
              </Button>
            </Link>
            <div className="explanation">
              <Trans i18nKey="Login.ForgotPasswordDescription">
              If you have forgotten your password,<br/>please click the button below to reset it.
              </Trans>
            </div>
            <Link to="/forgotpass">
              <Button id="move-button">
                <Trans i18nKey="Login.ForgotPassword">Forgot Password</Trans>
              </Button>
            </Link>
            <Col className="HeartLogo" md={4}  xs={10} mdOffset={4}  xsOffset={1}></Col>
          </Row>
        </FormGroup>
      </div>
    );
  }
}

export default withTranslation()(withRouter(LoginForm));



// WEBPACK FOOTER //
// ./src/component/Login/LoginForm.js